import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUnAssignCalendarHolidaysFromResourceFailure({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isFailure : false;
    },
    isUnAssignCalendarHolidaysFromResourcePending({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isPending : false;
    },
    isUnAssignCalendarHolidaysFromResourceSuccess({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
